var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-detail view-container"},[_c('BreadCrumb',{staticClass:"bread-crumb"}),_c(_vm.componentId,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }